import { graphql } from 'react-relay';

export const overviewSectionFragment = graphql`
    fragment OverviewSection_pageSection on OverviewSection {
        title
        titleImageUrl
        titleImageBackgroundUrl
        anchorName
        overviewSectionText: text
        detailPageLink {
            ...SimpleLink_simpleLink
        }
    }
`;
